import { AlertCircle, ChevronDown, ChevronUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const TrainingTips = ({ showTips, setShowTips }) => {
  return (
    <Card className="glass border-0 mt-6">
      <CardHeader
        className="cursor-pointer hover:bg-gray-50 transition-colors"
        onClick={() => setShowTips(!showTips)}
      >
        <CardTitle className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <AlertCircle className="w-5 h-5" />
            <span>Conseils pour l'Entraînement par Chat</span>
          </div>
          <button
            className="p-1 rounded-full hover:bg-gray-200 transition-colors"
            onClick={(e) => { e.stopPropagation(); setShowTips(!showTips); }}
          >
            {showTips ? <ChevronUp className="w-5 h-5 text-gray-600" /> : <ChevronDown className="w-5 h-5 text-gray-600" />}
          </button>
        </CardTitle>
      </CardHeader>

      {showTips && (
        <CardContent>
          <div className="space-y-4">
            <div>
              <h4 className="font-semibold text-gray-700 mb-2">Nouvelle Fonctionnalité Vocale:</h4>
              <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm text-gray-600">
                <li>- <strong>Focus automatique:</strong> Le curseur se positionne automatiquement</li>
                <li>- <strong>Microphone intégré:</strong> Cliquez sur l'icône micro pour parler</li>
                <li>- <strong>Transcription automatique:</strong> Votre voix devient du texte</li>
                <li>- <strong>Cycle automatique:</strong> Micro s'active après chaque réponse du citoyen</li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-gray-700 mb-2">Conseils d'Entraînement:</h4>
              <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm text-gray-600">
                <li>- <strong>Commencez par:</strong> "911 [police/ambulance/pompier], quelle est votre adresse?"</li>
                <li>- Posez des questions claires et précises</li>
                <li>- Demandez des détails sur la localisation</li>
                <li>- Évaluez l'état de la victime</li>
                <li>- Restez calme et professionnel</li>
                <li>- Donnez des instructions de sécurité</li>
                <li>- Confirmez les informations importantes</li>
              </ul>
            </div>
          </div>
        </CardContent>
      )}
    </Card>
  );
};

export default TrainingTips;
